import styled from 'styled-components'

export const StyledDesktopContainer = styled.div`
  display: grid;
  column-gap: 2.5%;
  grid-template-columns: minmax(120px, 144px) minmax(260px, 1fr)  minmax(138px, 152px)  minmax(58px, 78px);
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  background: #FFF;

  &:not(:last-child) {
    margin-bottom: 24px;
  }

  position: relative;
`

export const StyledPrice = styled.span`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`

export const StyledPriceAndRemoveContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`

export const StyledWidgetsContainer = styled.div`
  display: grid;
  gap: 12px;
`

export const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-48-px, 8px);
`
